export const stats = [
  { value: '+600', label: 'Fertige Sequenzen & Karten' },
  { value: '+1.500', label: 'Zufriedene Lehrer' },
  { value: '4.200+', label: 'Gesparte Planungsstunden' },
  { value: '98%', label: 'Weiterempfehlungsrate' },
]

export const differenceStats = [
  { value: '+600', label: 'Fertige Sequenzen & Karten (Basis bis Meisterschaft)' },
  { value: '6', label: 'Komplette digitale Bände' },
  { value: '100%', label: 'Sofort-Download' },
]

export const beforeItems = [
  'Stundenlanges Planen jeder einzelnen Stunde von Null auf, Suchen auf verschiedenen Websites und Social Media',
  'Erklärungsnot: Nicht wissen, wie man komplexe Konzepte oder Ausrichtungen einfach erklärt',
  'Keine klare Verbindung zwischen physischer Praxis, Philosophie und Anatomie',
  'Schwierigkeiten beim Erstellen von Varianten für verschiedene Level oder Einschränkungen',
]

export const afterItems = [
  '5 Minuten Durchsicht und du bist bereit, mit voller Sicherheit in den Unterricht zu gehen',
  'Fließende, inspirierende Sequenzen mit integrierten hochauflösenden Grafiken',
  'Quiz, Tests und Bewertungsschemata zu 100% fertig, um Fortschritte zu messen',
  'Schüler, die wirklich verstehen – dank Infografiken und Konzept-Maps',
]

export const packItems = [
  {
    emoji: '📚',
    title: '6 Bände basierend auf dem Unterrichtsjahr',
    text: 'Von der Entdeckung der Sinne bis zu fortgeschrittenen Inversionen und Meisterschaft',
  },
  {
    emoji: '🧘‍♀️',
    title: '«Ready-to-use» Unterrichts-Scripts',
    text: 'Didaktische Cues, die dir genau sagen, was du während der Stunde sagen kannst',
  },
  {
    emoji: '📐',
    title: 'Visuelles Yoga: Infografiken & Maps',
    text: '8K-Grafiken, die unsichtbare Prozesse verständlich machen: Energiefluss, Anatomie und Ausrichtung',
  },
  {
    emoji: '📊',
    title: 'Tests, Lösungen & Inklusions-Support',
    text: 'Werkzeuge für einen wirklich inklusiven Unterricht für alle Schülertypen',
  },
  {
    emoji: '🔑',
    title: 'Answer Keys (Lösungsschlüssel)',
    text: 'Komplette Lösungen für stressfreie und sofortige Korrekturen',
  },
]

export const pageSamples = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/8T3tdeEfgjszpNZeYqeo2s/Captura-de-pantalla-2026-09-09-a-la_s_-6.22.19_p._m..webp',
    level: 'Ausrichtung · Woche 2',
    title: 'Bridge Pose — 3 Regeln',
    caption:
      'Setu Bandhasana auf drei klare Ausrichtungsregeln reduziert: Fersen statt Zehen, Knie über den Knöcheln, Schulterblätter nach hinten – plus fertiger Coaching Cue für Runde 4.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/uMvvh3GuuEy6QBXPLPuLD1/Captura-de-pantalla-2026-09-09-a-la_s_-6.25.32_p._m..webp',
    level: 'Korrektur · Technikkarte',
    title: 'Plank: die 3 Positionen',
    caption:
      'Pike, Sag und die korrekte Neutral-Linie direkt nebeneinander – damit du Beckenkippungen im Raum sofort erkennst und benennst. Halteziel: 30 Sekunden, 5 Runden.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/oKufxFj8JGZHbii3wvdFzR/Captura-de-pantalla-2026-09-09-a-la_s_-6.28.15_p._m..webp',
    level: 'Grundlagen · Woche 1 · Tag 2',
    title: 'Baum-Pose — Propriozeption',
    caption:
      'Drishti, Fußsohle am inneren Oberschenkel und die 4 aktiven Punkte des Standbeins beschriftet – mit wörtlichem Cue für den Seitenwechsel nach 30 Sekunden.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/25hyxYAkbXXzupxduNi7Va/Captura-de-pantalla-2026-09-09-a-la_s_-6.29.46_p._m..webp',
    level: 'Stundenbild · 60 Minuten',
    title: 'Montag 60 Min: sanfte Forward Folds',
    caption:
      'Die komplette Stunde in sechs Phasen mit Minutenangaben – vom Ankommen über Mobilisation und Uttanasana bis Cool-Down und Savasana.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/xxTCHm9BeVfQzjbXguT8C3/Captura-de-pantalla-2026-09-09-a-la_s_-6.30.08_p._m..webp',
    level: 'Yin · Inklusivität',
    title: 'Die Kunst des Loslassens: Uttanasana Yin',
    caption:
      'Der Weg in die Vorbeuge in drei Schritten, ein Script zum Vorlesen und die Block-Modifikation für alle, denen der Boden noch weit weg ist.',
  },
]

export const bonuses = [
  {
    title: '5-MINUTEN KLASSENSTART-CHECKLIST',
    was: '€10',
    text: 'Das System für einen perfekten Start: Alles, was du tun musst, bevor der erste Schüler den Raum betritt',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/4ef6d544-f994-4bd5-ae84-326b351759fc.jpg',
  },
  {
    title: '120 YOGA-CUES FÜR PROFESSIONELLE LEHRER',
    was: '€12',
    text: 'Präzise Anleitung: Die richtigen Worte für Ausrichtung, Atem und Fokus, um deine Schüler sicher zu führen',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/5038d695-efad-4c34-8747-4d7b7b5b336a.jpg',
  },
  {
    title: 'ASANA-VARIATIONEN NOTFALL-KARTEN',
    was: '€10',
    text: 'Sei auf alles vorbereitet: Schnelle visuelle Lösungen für Schüler mit Einschränkungen oder unterschiedlichen Levels',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/1f83d082-391a-448a-80b2-b5c7169c1bc9.jpg',
  },
  {
    title: 'SCHÜLER-LEVEL EINSCHÄTZUNGSBOGEN',
    was: '€10',
    text: 'Professionalisiere deine Didaktik: Ein fertiges System, um den Fortschritt deiner Schüler objektiv zu bewerten',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/4e01cb92-d3cf-4812-8e04-c46003b41596.jpg',
  },
  {
    title: '30/45/60/75-MINUTEN KLASSENMAPS',
    was: '€10',
    text: 'Absolute zeitliche Flexibilität: Passe jede Sequenz perfekt an den vorgegebenen Zeitrahmen an',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/bf108997-0ede-40ca-80f9-78564c5f4771.jpg',
  },
]

export const offerRows = [
  { label: 'YOGA BEREIT™ Pack (6 Digitale Bände)', value: '€77' },
  { label: '5 Strategische Exklusiv-Boni', value: '€52' },
]

export const testimonials = [
  {
    quote:
      'Ich habe endlich meine Abende zurück. Meine Schüler lieben die neuen visuellen Karten.',
    name: 'Chiara M.',
    location: 'Berlin 🇩🇪',
  },
  {
    quote:
      'Professionelles Material, sofort einsatzbereit. Die Voice-Scripts haben mir unglaubliche Sicherheit gegeben.',
    name: 'Lukas B.',
    location: 'München 🇩🇪',
  },
  {
    quote:
      'Von den Grundlagen bis zu fortgeschrittenen Klassen – die einzige Investition, die eine Yogalehrerin braucht.',
    name: 'Elena V.',
    location: 'Wien 🇦🇹',
  },
]

export const faqs = [
  {
    q: 'Wie erhalte ich das Material?',
    a: 'Sofortiger Download-Link per E-Mail direkt nach dem Kauf.',
  },
  {
    q: 'Funktioniert es für alle Level?',
    a: 'Ja, von absoluten Anfängern bis zur Meisterschaft.',
  },
  {
    q: 'Gibt es monatliche Kosten?',
    a: 'Nein, nur eine Einmalzahlung.',
  },
]
